<template>
<div>
    <div class="container">
        <div id="btn-open-caja" class="d-flex justify-content-end pt-2 mt-2">
            <div class="btn-group btn-home" role="group">
                <button type="button" class="btn btn-outline-main bg-main text-white" @click="mtdBackRol">
                    <i class="fas fa-recycle"></i> Cambiar de Rol
                </button>
            </div>
        </div>
        <div class="row row-home" id="div_conte_2">
            <div id="div_conte-home" class="col-md-10 mx-auto">
                <div class="bg-secondary text-white bg-opacity-10">
                    <div class="text-center py-4 px-5" id="scroll-div-home">
                        <div class=" row row-home">
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('add')">
                                ADD
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('altura')">
                                ALTURA
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('banks')">
                                BANCOS
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('boxes')">
                                CAJAS
                            </button>                      
                        </div>
                        <div class=" row row-home">
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('centrales')">
                                CENTRAL DE COSTO
                            </button>  
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('color')">
                                COLORES
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('design')">
                                DISEÑO
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('doctores')">
                                DOCTORES
                            </button>
                        </div>
                        <div class=" row row-home">
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('marca')">
                                MARCAS
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('materials')">
                                MATERIALES
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('montaje')">
                                MONTAJE
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('subsubcategoria')">
                                MONTURAS
                            </button>
                        </div>
                        <div class=" row row-home">
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('range')">
                                RANGOS
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('roles')">
                                ROLES
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('sede')">
                                SEDES
                            </button>
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('voucherType')">
                                TIPO DE COMPROBANTES
                            </button>
                        </div>
                        <div class=" row row-home">
                            <button class="div-campus fw-bold col m-2 p-2 text-white" @click="changePage('usuarios')">
                                USUARIOS
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'homeMaintenance',
    data() {
        return {
            page: null
        }
    },
    methods: {
        changePage(page) {
            this.$emit('changePage', page)
        },
        mtdBackCampus: function () {
            this.$emit('mtdBackCampus')
        },
        mtdBackRol: function(){
        this.$emit("mtdBackRol");
    }
    }
}
</script>
